import { Box, Flex, Stack, type StackProps, Text } from '@chakra-ui/react';

interface ListCardProps extends StackProps {
  cardTitle: React.ReactNode;
  cardSubtitle?: React.ReactNode;
  cardPrimaryAction?: React.ReactNode;
  cardContent?: React.ReactNode;
}

export function ListCard(props: ListCardProps) {
  const { cardTitle, cardSubtitle, cardPrimaryAction, cardContent, ...stackProps } = props;

  return (
    <Stack
      p="6"
      gap="4"
      w="full"
      alignItems="flex-start"
      alignSelf="stretch"
      borderWidth="1px"
      borderRadius="lg"
      borderColor="border.default"
      {...stackProps}
    >
      <Flex justify="space-between" alignItems="center" w="full">
        <Box>
          <Text as="h2" textStyle="xl" fontWeight="medium">
            {cardTitle}
          </Text>
          <Text color="fg.muted" textStyle="sm">
            {cardSubtitle}
          </Text>
        </Box>
        {cardPrimaryAction}
      </Flex>
      {cardContent != null ? <Box width="full">{cardContent}</Box> : null}
    </Stack>
  );
}

export default ListCard;
